import { Calendar, LineChart, Wrench, Zap } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "maintenance",
  slug: "manutencao",
  icon: Wrench,
  useCases: [
    { key: "preventive", icon: Calendar },
    { key: "predictive", icon: Zap },
    { key: "workOrders", icon: Wrench },
    { key: "assets", icon: LineChart },
  ],
  benefits: ["downtime", "costs", "lifespan", "traceability"],
  formApplication: "Manutenção",
};

const Manutencao = () => <ApplicationPage config={config} />;

export default Manutencao;
